
















import AspectRatioBlockContainer from './AspectRatioBlockContainer.vue';
import { Component, Prop } from 'vue-property-decorator';
import { HeroBannerViewObject, Alignment } from '@/types/apiServerContract';
import BaseBlock from './BaseBlock.vue';

@Component({
    components: { BaseBlock }
})
export default class HeroBannerBlock extends AspectRatioBlockContainer {
	@Prop({
	    required: true,
	    type: Object
	})
	content!: HeroBannerViewObject;

	get captionStyle() {
	    return `
			color: ${this.content.captionText.color};
			background-color: ${this.content.captionText.backgroundColor};
			padding: ${this.content.captionText.padding};
			border-radius: ${this.content.captionText.borderRadius}px;
			font-size: ${this.content.captionText.size}px;
			font-weight: ${this.content.captionText.bold ? 'bold' : '400'}
		`;
	}

	get alignment() {
	    switch (this.content.captionAlignment) {
	    case Alignment.Left:
	        return 'left';
	    case Alignment.Right:
	        return 'right';
	    case Alignment.Center:
	        return 'center';
	    default:
	        throw new Error('Unknown alignment type ' + this.content.captionAlignment);
	    }
	}
}
